<template>
  <div>
    <div class="content">
      <div class="title">添加求职期望</div>
      <div class="cont">
        <div class="box">
          <div class="name">期望职位</div>
          <div class="selectBox" @click="qwClick">
            <div class="contBox">
              <div class="text" v-if="qwData.length == 0">请选择</div>
              <div class="li dis-cent" v-for="(item, index) in qwData">
                <div class="name">{{ item.categoryname }}</div>
                <div
                  class="iconfont icon-close close"
                  @click.stop="qwDelClick(index)"
                ></div>
              </div>
            </div>
            <div class="iconfont icon-barrage barrage dis-cent"></div>
          </div>
        </div>
        <div class="box">
          <div class="name">期望工作地址</div>
          <a-dropdown>
            <div class="selectBox">
              <div class="contBox">
                <div class="text" :class="areaTxt == '请选择' ? '' : 'hei'">
                  {{ areaTxt }}
                </div>
              </div>
              <div class="iconfont icon-barrage barrage dis-cent"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick"
              :selectedKeys="[typeData['期望工作地址']]"
            >
              <a-menu-item
                :key="'期望工作地址_' + item.id + '_' + item.name"
                v-for="item in areaList"
                >{{ item.name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
        </div>
        <div class="box">
          <div class="name">期望行业</div>
          <div class="selectBox" @click="tradeClick">
            <div class="contBox">
              <div class="text" v-if="zwData.length == 0">请选择</div>
              <div class="li dis-cent" v-for="(item, index) in zwData">
                <div class="name">{{ item.tradeTxt }}</div>
                <div
                  class="iconfont icon-close close"
                  @click.stop="zwDelClick(index)"
                ></div>
              </div>
            </div>
            <div class="iconfont icon-barrage barrage dis-cent"></div>
          </div>
        </div>
        <div class="box">
          <div class="name">期望薪资</div>
          <div class="qianBox">
            <a-select
              show-search
              placeholder="月薪"
              option-filter-prop="children"
              style="width: 100px; height: 44px"
              v-model="qValue"
              :filter-option="filterOption"
              @change="handleChange"
            >
              <a-select-option
                :value="item.name"
                v-for="item in qMoney"
                :key="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <div class="jian dis-cent">-</div>
            <a-select
              show-search
              placeholder="月薪"
              option-filter-prop="children"
              style="width: 100px; height: 44px"
              v-model="hValue"
              :filter-option="filterOption"
              @change="hhandleChange"
            >
              <a-select-option v-for="item in hMoney" :key="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <div class="myBox" @click="myClick">
              <div class="kuang dis-cent" :class="myShow ? 'on' : ''">
                <div class="iconfont icon-right" v-if="myShow"></div>
              </div>
              <div class="txt" :class="myShow ? 'txtOn' : ''">面议</div>
            </div>
            <!-- <div class="cheng dis-cent">x</div>
            <a-select
              show-search
              placeholder="月数"
              option-filter-prop="children"
              style="width: 100px; height: 44px"
              v-model="yValue"
              :filter-option="filterOption"
              @change="mothHandleChange"
            >
              <a-select-option
                :value="item.name"
                v-for="item in yMoney"
                :key="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select> -->
          </div>
        </div>
      </div>
      <div class="tcBom">
        <div class="qbtn dis-cent" @click="qxClick">取消</div>
        <div class="btn dis-cent" @click="qrClick">确定</div>
      </div>
    </div>
    <XuanzeLd v-if="ldShow" :ldData="zwData" @show="ldShowDelClick" />
    <XuanzeLb v-if="qwShow" :num="1" @show="qwShowDelJs" :qwData="qwData" />
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
} from "ant-design-vue";
import XuanzeHy from "../component/xuanzeHy.vue";
import XuanzeZw from "../component/xuanzeZw.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; // 引入中文语言包
import XuanzeLd from "../component/xuanzeLd.vue";
import XuanzeLb from "../component/xuanzeLb.vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    XuanzeHy,
    XuanzeZw,
    XuanzeLd,
    XuanzeLb,
  },
  name: "",
  data() {
    return {
      myShow: false,
      size: "default",
      qwShow: false,
      qwData: [],
      addTxt: "请选择",
      qMoneyOn: null,
      qValue: undefined,
      qMoney: [],
      hValue: undefined,
      hMoney: [],
      yValue: undefined,
      yMoney: [],
      areaTxt: "请选择",
      areaId: "",
      areaList: [
        {
          id: 1146,
          pid: 1142,
          code: 331021,
          name: "不限",
          car: "",
          is_sent: 1,
          is_delete: 0,
        },
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
      ],
      typeData: {
        期望工作地址: "",
      },
      tradeData: {},
      ldShow: false,
      qwShow: false,
      qwData: [],
      zwShow: false,
      zwData: [],
    };
  },
  props: {
    info: { type: Object, default: {} },
  },
  created() {
    console.log(this.info);
    if (this.info.trade) {
      let zwData = [
        {
          tradeOn: this.info.trade,
          tradeTxt: this.info.trade_cn,
        },
      ];
      this.zwData = zwData;
    }
    if (this.info.intention_jobs_id) {
      let qwData = [
        {
          key: this.info.intention_jobs_id,
          categoryname: this.info.intention_jobs,
          zTxt: this.info.intention_jobs,
          id: this.info.intention_jobs_id.split(",")[2],
        },
      ];
      this.qwData = qwData;
    }
    if (this.info.minprice) {
      this.qValue = this.info.minprice + "K";
      this.hValue = this.info.maxprice + "K";
      this.yValue = this.info.pricemonth + "月";
    }
    if (this.info.district) {
      if (this.info.district.indexOf("1142") == -1) {
        this.areaId = this.info.district;
        this.areaTxt = this.info.district_cn;
      } else {
        this.areaId = this.info.district.split("1142,1146,")[1];
        this.areaTxt = this.info.district_cn.split("台州/玉环/")[1];
      }
    }
    if (this.info.minprice == 0 && this.info.maxprice == 0) {
      this.myShow = true;
    }
    for (let i = 0; i < 100; i++) {
      this.qMoney.push({
        name: i + 1 + "K",
        id: i + 1,
      });
    }
    for (let i = 12; i < 30; i++) {
      this.yMoney.push({
        name: i + "月",
        id: i,
      });
    }
  },
  methods: {
    myClick() {
      this.myShow = !this.myShow;
    },
    tradeClick() {
      this.ldShow = true;
    },
    ldShowDelClick(data) {
      console.log(data);
      this.ldShow = false;
      if (data.tradeOn) {
        this.zwData = [data];
      }
    },
    qwShowDelJs(data) {
      console.log(data);
      if (data) {
        if (data.data.length != 0) {
          this.qwData = data.data;
          this.zwid = data.data[0].key;
          this.zwTxt = data.data[0].zTxt;
        }
      }
      this.qwShow = false;
    },
    handleChange(value) {
      let on;
      for (let i = 0; i < this.qMoney.length; i++) {
        const e = this.qMoney[i];
        if (e.name == value) {
          on = i;
        }
      }
      this.qMoneyOn = on + 1;
      const newArray = this.removeElementsBeforeIndex(
        this.qMoney.slice(),
        on + 1
      );
      this.hMoney = newArray;
    },
    removeElementsBeforeIndex(arr, index) {
      if (index > 0) {
        arr.splice(0, index);
      } else if (index < 0) {
        throw new Error("Index out of range");
      }
      return arr;
    },
    hhandleChange(value) {
      console.log(value);
      this.hMoneyOn = value;
    },
    mothHandleChange(value) {
      console.log(value);
      this.mothMoneyOn = value.split("月")[0];
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    ddClick(e) {
      this.addTxt = e.key;
    },
    qwShowJs(data) {
      this.qwShow = false;
      this.qwData = data.data;
    },
    qwClick() {
      this.qwShow = true;
    },
    qwDelClick(i) {
      this.qwData.splice(i, 1);
    },
    hyClick(e) {
      let key = e.key.split("_");
      let data = {
        type: key[0],
        id: key[1],
        name: key[2],
      };
      this.typeData[key[0]] = e.key;
      if (key[0] == "期望工作地址") {
        this.areaTxt = data.name;
        this.areaId = data.id;
      }
      if (key[0] == "目前状态") {
        this.currentTxt = data.name;
        this.currentId = data.id;
      }
    },
    qxClick() {
      this.$emit("show");
    },
    qrClick() {
      let data = {
        ...this.info,
      };
      console.log(this.zwData);

      if (this.zwData.length != 0) {
        data.trade = this.zwData[0].tradeOn + "";
        data.trade_cn = this.zwData[0].tradeTxt;
      }
      if (!this.qwData[0]) {
        this.$message.error("请选择期望职位");
        return;
      }
      data.intention_jobs_id = this.qwData[0].key;
      data.intention_jobs = this.qwData[0].categoryname;
      if (this.myShow) {
        data.minprice = 0;
        data.maxprice = 0;
      } else {
      if (!this.qValue && !this.hValue) {
        this.$message.error("请选择期望薪资");
        return;
      }
        data.minprice = Number(this.qValue.split("K")[0]);
        data.maxprice = Number(this.hValue.split("K")[0]);
      }
      // data.pricemonth = Number(this.yValue.split("月")[0]);
      data.district = "1142,1146," + this.areaId;
      data.district_cn = "台州/玉环/" + this.areaTxt;
      // data.companyname = this.companyname;
      // data.achievements = this.achievements;
      // data.start_time = this.startMonth;
      // data.end_time = this.endMonth;
      // data.jobs = this.jobs;
      console.log(data);
      if (!data.district) {
        this.$message.error("请选择期望工作地址");
        return;
      }
      if (!data.trade) {
        this.$message.error("请选择期望行业");
        return;
      }
      // if (!data.minprice || !data.maxprice || !data.pricemonth) {
      //   this.$message.error("请填写职位名称");
      //   return;
      // }
      console.log(data);
      data = JSON.stringify(data);
      this.$post("/nozzle/web/member_job_save", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.$emit("show", 1);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  background-color: #f1f5fc;
  padding: 20px 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  .title {
    font-size: 15px;
  }
  .cont {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .box {
      width: calc(50% - 30px);
      margin-right: 60px;
      margin-bottom: 20px;
      .selectBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        .contBox {
          width: calc(100% - 50px);
          display: flex;
          flex-wrap: wrap;
          .text {
            height: 38px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            color: #9c9c9c;
            margin-bottom: 2px;
          }
          .hei {
            color: #000;
          }
          .li {
            background-color: #e2e4ec;
            border-radius: 10px;
            height: 38px;
            padding: 0 6px 0 10px;
            margin-right: 2px;
            margin-bottom: 2px;
            color: #000;
            .iconfont {
              position: relative;
              top: 1px;
              font-size: 14px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }
        .barrage {
          width: 50px;
          font-size: 25px;
          cursor: pointer;
          color: #9c9c9c;
        }
      }
      .selectBox:hover {
        border: 1px solid #147ee0;
        .contBox {
          .text {
            color: #147ee0;
          }
        }
      }
      .qianBox {
        margin-top: 10px;
        display: flex;
        align-items: center;
        .myBox {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #888;
          padding-left: 15px;
          cursor: pointer;
          .kuang {
            width: 18px;
            height: 18px;
            border-radius: 5px;
            border: 1px solid #c9c9c9;
            margin-right: 5px;
          }
          .on {
            color: #fff;
            background-color: #147ee0;
            border: 1px solid #147ee0;
          }
          .txtOn {
            color: #147ee0;
          }
        }
        .jian {
          width: 30px;
        }
        .cheng {
          width: 50px;
        }
        /deep/.ant-select-selection--single {
          height: 44px;
          border-radius: 10px;
        }
        /deep/.ant-select-selection__rendered {
          height: 44px;
        }
        /deep/.ant-select-selection-selected-value {
          height: 44px;
          line-height: 44px;
        }
        .xuanBox {
          box-sizing: border-box;
          border: 1px solid #d8d8d8;
          background-color: #fff;
          height: 44px;
          width: 100px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 15px;
          color: #9c9c9c;
          cursor: pointer;
        }
        .xuanBox:hover {
          border: 1px solid #147ee0;
          color: #147ee0;
        }
      }
    }
    .box:nth-child(2n) {
      margin-right: 0;
    }
  }
  .tcBom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      width: 90px;
      border-radius: 5px;
      height: 40px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
    .qbtn {
      cursor: pointer;
      width: 90px;
      border-radius: 5px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #147ee0;
      color: #147ee0;
      margin-right: 20px;
    }
  }
}
</style>
